import { createTableConfig } from '../createTableConfig';

export const workOrderStateMachine = createTableConfig({});
